import './App.css';
import './assets/css/lhrcPrimeTheme2.css';
import './assets/css/dashboardcards.css';
// import 'primereact/resources/themes/saga-blue/theme.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './assets/css/resetPrimeCSS.css'
import { DataProvider } from './context/DataContext';
import Auth from './auth/Auth';




function App() {
  
  return (
    <div className='App'>
      <DataProvider>
        <Auth/>
      </DataProvider>
    </div>
  );
}

export default App;
